// extracted by mini-css-extract-plugin
export default {"customers":"hY","wrapper":"iY","carousel":"jY","carousel_inner_wrapper":"kY","top_quote":"lY","bottom_quote":"mY","carousel_wrapper":"nY","feedbacks_wrapper":"oY","arrows":"pY","prev":"qY","img":"rY","review_btn":"sY"};
    if(module.hot) {
      // 1715188239253
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  